import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { initialize, LDClient, LDFlagSet } from 'launchdarkly-js-client-sdk';
import { environment } from '../../../../environments/environment';
import { State } from '@app/core/ngrx/reducers';
import { Store } from '@ngrx/store';
import { UserActions } from '@app/core/ngrx/actions';
import { datadogRum } from '@datadog/browser-rum';

@Injectable({
    providedIn: 'root',
})
// https://web.archive.org/web/20180613020259/https://github.com/launchdarkly/ld-tour-of-heroes
export class LaunchDarklyService {
    ldClient: LDClient;
    public flags: LDFlagSet;
    flagChange: Subject<Object> = new Subject<Object>();

    constructor(private store: Store<State>) {}

    async initLD(user: { id: string }) {
        try {
            if (user && user.id) {
                // default object used in case the user does not connect to launch darkly
                // init the client with the client id from environment
                // const options = { allAttributesPrivate: false };
                // this.ldClient = initialize(
                //     environment.LAUNCHDARKLY_CLIENT_ID,
                //     {
                //         anonymous: false,
                //         key: user.id,
                //     },
                //     options
                // );

                // await this.ldClient
                //     .waitForInitialization()
                //     .then(() => {
                this.setFlags();
                //     })
                //     .catch((err) => {
                //         console.log(err);
                //     });
            } else {
                this.flagChange.next({});
            }
        } catch (error) {
            console.log(error);
            this.flagChange.next({});
        }
    }

    setFlags() {
        try {
            // get LD flags from client class
            // this.flags = this.ldClient.allFlags();
            this.flags = { 'static-itinerary-apply-now': true };
            this.flags = { 'search-base-filter': true };

            // set flags to subject
            this.flagChange.next(this.flags);
            // set flags to ngrx store
            this.store.dispatch(
                UserActions.setUserConfig({
                    userConfig: this.flags,
                })
            );
        } catch (error) {
            console.log(error);
        }
    }

    changeUser(user) {
        if (user && user.id && this.ldClient) {
            this.ldClient.identify({
                key: user.id,
                // custom: { acquisition: user.acquisition ? 'true' : 'false' },
            });
        } else {
            this.ldClient.identify({ anonymous: false });
        }
    }

    track(event, user, data?, metricValue?) {
        if (this.ldClient) {
            if (event === 'completedprofileblock') {
                this.ldClient.track(event, { user });
            } else {
                this.ldClient.track(event, {}, 1);
            }
        }
    }
}
